module.exports = __webpack_public_path__ + "img/logo-installment-KTC.950e9eac.png";